import React from "react";
//#region types
import { TodoCardProps } from "models/propTypes/todoPropTypes";
import { TranslationKeys } from "translations";
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
import { CurrencyEnums } from "models/enums";
import { EventConstants } from "utils/constants";
//endregion
//#region components
import TopTodoCard from "../../_partials/topTodoCard";
import { TitledContainerInner, EntityCardContent } from "components/common";
import { UnhandledBankPaymentsFooter, UnhandledBankPaymentsList } from "components/payment";
//#endregion
//#region services
import { usePaymentService } from "serviceHooks";
import { BankPaymentInformationService } from "services";
//#endregion
import { EventHelper, LocalizationHelperInstance, PaymentHelper } from "utils/helpers";

const UnhandledBankPaymentsTodo: React.FC<TodoCardProps> = (props) => {
  const paymentService = usePaymentService();
  const [total, setTotal] = React.useState<number>(0);
  const [unhandledBankPayments, setUnhandledBankPayments] =
    React.useState<WintSuperkollAPIModel.BankPaymentInformation>();
  const [loading, setLoading] = React.useState(false);

  const initialSelectedPayments = {
    incomingInvoiceManualPayments: [],
    incomingInvoicePaymentFilesToSign: [],
    receiptPayoutFilesToSign: [],
    salaryPayoutFilesToSign: [],
    manualPayoutsToSign: [],
  } as WintSuperkollAPIModel.BankPaymentInformation;

  const [selectedPayments, setSelectedPayments] =
    React.useState<WintSuperkollAPIModel.BankPaymentInformation>(initialSelectedPayments);

  React.useEffect(() => {
    setUnhandledBankPayments(props.item.unhandledBankPayments);
    const fullTotal =
      props.item.unhandledBankPayments && PaymentHelper.calculateTotal(props.item.unhandledBankPayments);
    fullTotal && setTotal(fullTotal);
  }, [props.item.unhandledBankPayments]);

  const selectedPaymentsCount = PaymentHelper.getTotalPaymentsCount(selectedPayments);
  const allPaymentsCount = unhandledBankPayments ? PaymentHelper.getTotalPaymentsCount(unhandledBankPayments) : 0;

  const onPaymentsSelectionChange = (payments: WintSuperkollAPIModel.BankPaymentInformation) => {
    setSelectedPayments(payments);
  };

  const reloadTodo = (onSuccess?: (item: WintSuperkollAPIModel.BankPaymentInformation) => void) => {
    setSelectedPayments(initialSelectedPayments);
    if (unhandledBankPayments) {
      setLoading(true);
      paymentService
        .getUnhandledBankPayments()
        .then((result) => {
          onSuccess && onSuccess(result);
          props.onActionSuccess();
        })
        .finally(() => setLoading(false));
    }
  };

  const onUserProfileClick = () => {
    EventHelper.publishEvent(EventConstants.CloseDrawer);
  };

  return (
    <EntityCardContent
      topTodoCard={
        <TopTodoCard
          item={props.item}
          descriptionHeadingOne={`${LocalizationHelperInstance.getFormattedCurrency(total)} ${
            CurrencyEnums.CurrencyCode.SEK
          }`}
          descriptionHeadingTwo={`${allPaymentsCount} ${LocalizationHelperInstance.getFormattedMessage(
            TranslationKeys.Common.Pc
          )}`}
          footerText={`${LocalizationHelperInstance.getFormattedMessage(
            TranslationKeys.Common.Due_Date
          )}: ${LocalizationHelperInstance.getFormattedDate(
            BankPaymentInformationService.getDueDate(props.item.unhandledBankPayments)
          )}`}
        />
      }
      todoMainSection={
        <TitledContainerInner
          header={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Payments.UnhandledBankPaymentsHeader)}
          subHeader={LocalizationHelperInstance.getFormattedMessage(
            TranslationKeys.Payments.UnhandledBankPaymentsSubHeader
          )}
        />
      }
      footer={
        <UnhandledBankPaymentsFooter
          selectedPayments={selectedPayments}
          selectedPaymentsCount={selectedPaymentsCount}
          reloadHandler={reloadTodo}
          disableSuccessMessages
        />
      }
      infoViewer={
        <UnhandledBankPaymentsList
          key={`unhandledBankPaymentsList`}
          bankPaymentInformation={unhandledBankPayments}
          onPaymentSelectionsChange={onPaymentsSelectionChange}
          onUserProfileClick={onUserProfileClick}
          selectedPayments={selectedPayments}
        ></UnhandledBankPaymentsList>
      }
      loading={loading}
    ></EntityCardContent>
  );
};

export default UnhandledBankPaymentsTodo;
